// extracted by mini-css-extract-plugin
export default {"container":"newRadioButtonsComponent_container__UClsh","checkmark":"newRadioButtonsComponent_checkmark__jn0+G"};